module.exports = __webpack_public_path__ + "media/Video 3b.17bc1731.mp4";